





























































import Vue from 'vue'
import {mapGetters, mapActions} from 'vuex'
import UploadImg from './UploadImg.vue'
import { TenantExtendServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import dayjs from 'dayjs'
import {  getLocalStorage } from "@/utils/storage";

const serviceProxy = new TenantExtendServiceProxy()

export default Vue.extend({
  name: 'Personalization',
  components: {
    UploadImg
  },
  data() {
    return {
      form: {},
      submitLoading: false,
      formValues: {
        loginLogo: '',
        bannerLogo: '',
        loginImage: '',
        loginSlogan: '',
        transferDate: ''
      } as any

    }
  },
  computed: {
    ...mapGetters(['userSettings', 'user']),
    // tips() {
    //   return {
    //     loginLogo: this.$t('page_theme_tip1'),
    //     bannerLogo: this.$t('page_theme_tip2'),
    //     loginImage: this.$t('page_theme_tip2')
    //   }
    // }
  },
  watch: {
    userSettings: {
      handler(val) {
        this.initialForm()
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.initialForm()
  },
  methods: {
    ...mapActions('user', ['getSetting']),
    // 获取个性化设置
    getPersonalizedSetting() {
      this.getSetting()
    },
    // 表单数据绑定
    initialForm() {
      if (this.userSettings && this.userSettings.hasOwnProperty()) {
        this.form = this.$form.createForm(this, {
          mapPropsToFields: () => {
            return {
              loginSlogan: this.$form.createFormField({
                value: this.userSettings.loginSlogan
              })
            }
          }
        })
        this.formValues = {...this.userSettings}
      } else if(getLocalStorage('USER_SETTING')) {
        let settings = getLocalStorage('USER_SETTING')
        this.form = this.$form.createForm(this, {
          mapPropsToFields: () => {
            return {
              loginSlogan: this.$form.createFormField({
                value: settings.loginSlogan
              })
            }
          }
        })
        this.formValues = {...settings}
      }
    },
    validateLoginSlogan(rule: any, value: any, callback: any) {
      if (value && value.length > 22) {
        callback(this.$t('page_theme_tip4'))
      } else {
        callback()
      }
    },
    beforeUpload(file: any) {
      // console.log(file)
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error(this.$t('page_theme_img_tip'))
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error(this.$t('page_theme_img_tip2'))
      }
      return isJpgOrPng && isLt2M
    },
    handleSubmit(e: any) {
      e.preventDefault()
      if (!this.formValues.loginLogo) {
        this.$message.error(this.$t('page_theme_submit_tip1'))
        return
      }
      if (!this.formValues.bannerLogo) {
        this.$message.error(this.$t('page_theme_submit_tip2'))
        return
      }
      if (!this.formValues.loginImage) {
        this.$message.error(this.$t('page_theme_submit_tip3'))
        return
      }
      this.submitLoading = true
      this.form.validateFieldsAndScroll((err: any, values: any) => {
        if (err) {
          this.submitLoading = false
          return
        }

        let params: any = {
          tenantId: this.user.tenantId
        }
        this.formValues.loginSlogan = this.form.getFieldValue('loginSlogan')
        this.formValues.transferDate = dayjs(this.formValues.transferDate).format('YYYY-MM-DD HH:mm:ss')
        Object.assign(params, this.formValues)
        serviceProxy.update(params).then(
          res => {
            this.submitLoading = false
            if (res) {
              this.$message.success(this.$t('page_theme_submit_success'))
              this.getPersonalizedSetting()
            }
          },
          err => {
            this.submitLoading = false
          }
        )
      })
    }
  }
})
